import getPages from './pages';
import isMultilingualSite from '../verifiers/is-multilingual-site';

const getHomePage = (rootState, locale) => {
  const homePath = isMultilingualSite() ? `/${locale}/` : '/';
  return getPages(rootState).find((page) => page.path === homePath) || null;
};

export default getHomePage;
